var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlaylist = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.869,
    height: 11.078,
    viewBox: "0 0 11.869 11.078",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -10.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.495,
    height: 1.583
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.495,
    height: 1.583
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.997)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.33,
    height: 1.583
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.913 16.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.333,181.333v4.748l3.956-2.374Z",
    transform: "translate(-213.333 -181.333)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlaylist);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS44NjkiIGhlaWdodD0iMTEuMDc4IiB2aWV3Qm94PSIwIDAgMTEuODY5IDExLjA3OCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMTAuNjY3KSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMy44MzIpIj48cmVjdCB3aWR0aD0iOS40OTUiIGhlaWdodD0iMS41ODMiLz48L2c+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMC42NjcpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cmVjdCB3aWR0aD0iOS40OTUiIGhlaWdodD0iMS41ODMiLz48L2c+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTYuOTk3KSI+PHJlY3Qgd2lkdGg9IjYuMzMiIGhlaWdodD0iMS41ODMiLz48L2c+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy45MTMgMTYuOTk3KSI+PHBhdGggZD0iTTIxMy4zMzMsMTgxLjMzM3Y0Ljc0OGwzLjk1Ni0yLjM3NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMTMuMzMzIC0xODEuMzMzKSIvPjwvZz48L2c+PC9zdmc+";